import { render, staticRenderFns } from "./Officials.vue?vue&type=template&id=82511536&scoped=true&"
import script from "./Officials.vue?vue&type=script&lang=js&"
export * from "./Officials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82511536",
  null
  
)

export default component.exports